export default function Features() {
  const features = [
    {
      icon: 'ri-24-hours-line',
      gradient: 'from-purple-500 to-pink-500',
      title: '24/7 Availability',
      description: 'Your AI receptionist never sleeps. Handle calls, inquiries, and appointments around the clock without hiring additional staff.'
    },
    {
      icon: 'ri-calendar-schedule-line',
      gradient: 'from-blue-500 to-cyan-500',
      title: 'Smart Scheduling',
      description: 'Automatically book appointments, send reminders, and manage your calendar with intelligent scheduling that syncs with your existing systems.'
    },
    {
      icon: 'ri-translate-2',
      gradient: 'from-green-500 to-emerald-500',
      title: 'Multi-Language Support',
      description: 'Communicate with customers in their preferred language. Our AI speaks over 30 languages fluently for global reach.'
    },
    {
      icon: 'ri-customer-service-2-line',
      gradient: 'from-orange-500 to-red-500',
      title: 'Natural Conversations',
      description: 'Advanced AI technology creates human-like conversations that understand context, tone, and intent for exceptional customer experiences.'
    },
    {
      icon: 'ri-line-chart-line',
      gradient: 'from-indigo-500 to-purple-500',
      title: 'Analytics & Insights',
      description: 'Get detailed reports on call volumes, customer inquiries, and performance metrics to make data-driven business decisions.'
    },
    {
      icon: 'ri-links-line',
      gradient: 'from-pink-500 to-rose-500',
      title: 'Seamless Integration',
      description: 'Connect with your existing CRM, calendar, and business tools. Works perfectly with Salesforce, HubSpot, Google Calendar, and more.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16">
          <div className="inline-block px-4 py-2 bg-purple-100 text-purple-600 rounded-full text-xs font-bold tracking-wider mb-4">
            CAPABILITIES
          </div>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight">
            Everything Your Business<br />Needs to Scale
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-white to-gray-50 rounded-3xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer border border-gray-100"
            >
              {/* Icon */}
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed text-base">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
